<template>
  <div id="settings-nav" class="content">
    <mu-row gutter>
      <mu-col width="100" tablet="40" desktop="30" class="bottom">
        <div class="tabletDesktopOnly">
          <mu-list class="routes">
            <mu-list-item v-for="route, index in routes" :key="'setting-route-' + index" :to="route.route"
                          :title="$t(route.i18n)" v-if="hideSettingsMenu(route.name)">
              <mu-icon class="left8" slot="left" :value="route.icon"/>
            </mu-list-item>
          </mu-list>
        </div>
      </mu-col>
      <mu-col width="100" tablet="60" desktop="70">
        <mu-paper class="settings">
          <mu-content-block style="margin-bottom: -28px;" class="mobileOnly"
                            v-if="$route.name !== 'SettingsEditMedications' && $route.name !== 'SettingsAddMedications'">
            <mu-row>
              <mu-col width="100" desktop="100" tablet="100">
                <mu-select-field :scroller="scroller" v-model="activeRoute" fullWidth>
                  <mu-menu-item v-for="route, index in routes" :key="'setting-nav-' + index" :title="$t(route.i18n)"
                                :value="route" v-if="hideSettingsMenu(route.name)"></mu-menu-item>
                </mu-select-field>
              </mu-col>
            </mu-row>
          </mu-content-block>
          <router-view></router-view>
        </mu-paper>
      </mu-col>
    </mu-row>
  </div>
</template>
<script>


  import ScrollerMixin from "../../mixins/ScrollerMixin"
  import HcpMixin from "../../mixins/HCPMixin"

  let settingsNavRoutes = [
    {
      name: "General",
      icon: "person",
      i18n: "message.settingsGeneralTitleText",
      route: "/settings/general"
    },
    {
      name: "Security",
      icon: "lock",
      i18n: "message.settingsSecurityTitleText",
      route: "/settings/security"
    },
    {
      name: "Subscription",
      icon: "payment",
      i18n: "message.settingsSubscriptionTitleText",
      route: "/settings/subscription"
    },
    {
      name: "Privacy",
      icon: "remove_red_eye",
      i18n: "message.settingsPrivacyTitleText",
      route: "/settings/privacy"
    },
    {
      name: "Notifications",
      icon: "notifications",
      i18n: "message.settingsNotificationsTitleText",
      route: "/settings/notifications"
    },
    {
      name: "Units",
      icon: "assessment",
      i18n: "message.settingsUnitsTitleText",
      route: "/settings/units"
    },
    {
      name: "Conditions",
      icon: "local_hospital",
      i18n: "message.settingsConditionsTitleText",
      route: "/settings/conditions"
    },
    {
      name: "Medications",
      icon: "healing",
      i18n: "message.settingsMedicationTitleText",
      route: "/settings/medications"
    },
    {
      name: "Food",
      icon: "local_dining",
      i18n: "message.settingsFoodTitleText",
      route: "/settings/food"
    },
    {
      name: "Dashboard",
      icon: "dashboard",
      i18n: "message.settingsDashboardTitleText",
      route: "/settings/dashboard"
    },
    {
      name: "Integrations",
      icon: "settings_input_hdmi",
      i18n: "message.settingsIntegrationTitleText",
      route: "/settings/integrations"
    },
    {
      name: "Preferences",
      icon: "settings_cog",
      i18n: "message.marketingPreferencesTitle",
      route: "/settings/preferences",
    },
    {
      name: "Activity",
      icon: "desktop_mac",
      i18n: "message.settingsActivityTitleText",
      route: "/settings/activity",
    },
  ];

  export default {
    mixins: [ScrollerMixin, HcpMixin],
    name: 'settings',
    watch: {
      '$route': function () {
        let self = this;
        self.setActiveRoute();
      },
      'activeRoute': function () {
        let self = this;
        self.$router.push({path: self.activeRoute.route})
      }
    },
    data() {
      return {
        routes: settingsNavRoutes,
        activeRoute: {}
      }
    },
    mounted() {
      let self = this;
      self.setActiveRoute();
    },
    methods: {
      hideSettingsMenu(name){
        let self = this;
        if( self.isHcpView ) {
          if(name === 'Preferences' || name === 'Integrations' || name === 'Dashboard' || name === 'Food' || name === 'Medications' || name === 'Conditions' || name === 'Units' || name === 'Privacy' || name === 'Notifications') {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      },
      setActiveRoute() {
        let self = this;
        const currentPath = self.$route.fullPath;
        self.activeRoute = self.routes.filter(function (item) {
          return item.route === currentPath
        })[0];
      }
    }
  }
</script>
<style lang="less">
  @import "../../styles/theme.less";

  #settings-nav {
    .routes {
      // No surrounding card — items sit directly on the page background.
      background: transparent;
      padding: 0;
      .mu-item {
        color: #000000;
        min-height: 52px;
      }
      .mu-item-wrapper {
        margin: 2px 0;
        border-radius: 12px;
        overflow: hidden;
        transition: background-color .2s ease-in-out;
        *:not(.mu-badge) {
          color: #5b617c !important;
        }
        .mu-icon {
          color: @primaryColor !important;
        }
        &:hover {
          background-color: fade(@primaryColor, 8%);
        }
        &.router-link-active {
          background-color: fade(@primaryColor, 12%);
          *:not(.mu-badge) {
            color: @primaryColor !important;
          }
        }
      }
    }
    .settings {
      .mu-card-header-title {
        .mu-card-title {
          font-size: 24px;
          font-weight: 500;
        }
        .mu-card-sub-title {
          line-height: 24px;
          margin: 6px 0 0;
          font-size: 15px;
          color: #000;
        }
      }
      .mu-item-title-row {
        line-height: 24px;
        font-size: 16px;
        color: #000;
        + div {
          line-height: 24px;
          font-size: 16px;
          color: fade(#4A4A4A, 50%);
        }
      }
      .mu-switch {
        .mu-switch-thumb {
          background-color: #F1F1F1;
          box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.24), 0 0 1px 0 rgba(0, 0, 0, 0.12);
        }
        .mu-switch-track {
          background: #C6C5C5 !important;
        }
        input[type="checkbox"]:checked {
          + .mu-switch-wrapper .mu-switch-track {
            background: fade(@primaryColor, 50%) !important;
          }
          + .mu-switch-wrapper .mu-switch-thumb {
            background-color: @primaryColor;
          }
        }
      }
    }
    #food-settings {
      .inputInPaper {
        margin: 0;
        .mu-text-field {
          margin: 0;
          .mu-text-field-content {
            padding: 7px 0 0 0;
            margin: 0;
          }
        }
      }
      .likes {
        .mu-list {
          > .mu-sub-header:first-child {
            color: #89c93b;
          }
        }
      }
      .dislikes {
        .mu-list {
          > .mu-sub-header:first-child {
            color: #e74c3c;
          }
        }
      }
      .likes, .dislikes {
        margin: 0 0 16px;
        .mu-list {
          > .mu-sub-header:first-child {
            line-height: 24px;
            padding: 16px;
            margin: 0;
            font-size: 16px;
          }
        }
      }
      .mu-icon-button {
        .mu-icon {
          color: @primaryColor;
        }
      }
    }
  }

  #settings {
    &-privacy, &-notifications {
      .settings {
        .mu-item {
          padding: 10px 16px;
        }
      }
    }
    &-units {
      .settings {
        .mu-card-text {
          padding-top: 8px;
        }
        .tab-selector {
          .label {
            line-height: 24px;
            font-size: 16px;
          }
        }
        .unitsList {
          .row {
            .col {
              display: block;
              padding: 9px;
              font-weight: 500;
              color: @primaryColor;
              border-left: 1px solid @primaryColor;
              -webkit-transition: all 100ms linear;
              -moz-transition: all 100ms linear;
              -ms-transition: all 100ms linear;
              -o-transition: all 100ms linear;
              transition: all 100ms linear;
              cursor: pointer;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              &.isSelectedTab {
                color: #FFFFFF;
              }
              &:first-child {
                border-left: 0;
              }
            }
          }
        }
      }
    }
  }

  @media (min-width: 601px) {
    #settings-nav .mobileOnly {
      display: none !important;
    }
  }

  @media (max-width: 600px) {
    #settings-nav .tabletDesktopOnly {
      display: none;
    }

    #settings-nav .mobileOnly {
      display: block;
    }
  }
</style>



// WEBPACK FOOTER //
// Layout.vue?0e072e3a